import React from 'react';
function Icon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 -960 960 960">
      <path fill={props.fill || '#1D252D'} d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v400L600-120H200Zm80-280h200v-80H280v80Zm0-160h400v-80H280v80Zm280 360 200-200H560v200Z"></path>
    </svg>;
}
export default Icon;